import { AutoMap } from "@automapper/classes";
import { EMPCAType } from "./mpca-type";
import { EDegradationLevel } from "./enums/degradation-level";

export class MPCA {
    @AutoMap()
    Code!: string;
    @AutoMap()
    Name!: string;
    @AutoMap()
    ScolaMaterial!: string;
    @AutoMap()
    DegradationLevel!: EDegradationLevel;

    public constructor(init?: Partial<MPCA>) {
        Object.assign(this, init);
    }
}